<template>

    <div class="d-flex justify-content-between">
        <QuestionWeight :template="template" type="freeText"/>
        <span @click="clearHandler"  class="reset-data-btn">Reset All</span>
    </div>
    <div :class="lightMood ? 'q-containerCopy' : 'q-container'">
        <div v-for="(q, idx) in template.questions.freeText.questions"
             :key="idx"
             class="q-body d-flex gap-3 justify-content-start">

            <div class="d-flex flex-column w-100 gap-3">


                <div class="d-flex flex-column  position-relative input-section">
                    <QuestionComponent :id="'freeText-q'+idx" :template="template" type="freeText" :index="idx"
                                       :validationCB="freeTextQuestionsValidation"/>

                    <div class="err" v-if="q.errors['question'].length > 0">
                        <div v-for="msg in q.errors['question']" class="text-danger">{{msg}}</div>
                    </div>
                </div>

                <div class="d-flex flex-column w-100 input-section">
                    <textarea id="a-1" type="text" placeholder="Enter Answer" class="q-input w-100"
                              autocomplete="off"
                              @input="answerTextChangeHandler($event, idx, 'freeText')"
                              v-model="q.answer">
                    </textarea>
                    <div class="err" v-if="q.errors['answer'].length > 0">
                        <div v-for="msg in q.errors['answer']" class="text-danger">{{msg}}</div>
                    </div>
                </div>
            </div>

            <div class="align-self-center"
                 v-if="(template.questions.freeText.questions.length - 1) === idx">
                        <span class="add-question"
                              @click="addQuestionHandler($event, 'freeText')">+</span>
            </div>
        </div>
    </div>

    <ConfirmationModal v-if="confirmFlag" :message="confirmMsg" confirmBtn="Yes" cancleBtn="No"
                       @close-modal="confirmModalHandler($event)"/>
    <span v-if="lightMood"></span>
</template>


<script>
    import {toRef, ref, defineAsyncComponent,computed} from "vue";
    import increaseTemplateQuestions from "../../../helpers/increaseTemplateQuestionsCounter";
    import decreaseTemplateQuestions from "../../../helpers/decreaseTemplateQuestionsCounter";
    import QuestionWeight from "../../components/QuestionWeight";
    import QuestionComponent from "../../components/templateComponents/questionComponent";
    const ConfirmationModal = defineAsyncComponent(() =>
        import ('../../components/ConfirmationModal')
    );
    import qustionValidation from "../../../validation/qustionValidation";
    import {useStore} from "vuex";

    export default {
        name: 'app',
        components: {QuestionWeight, QuestionComponent, ConfirmationModal},
        props: {
            template: Object
        },
        setup(props, context) {
            const store = useStore();
            const confirmFlag = ref(false);
            const confirmMsg = ref('');
            const template = toRef(props, 'template');
            const lightMood = computed({
                get() {
                    return store.state.settings.isLightMood;
                },
            });

            const addQuestionHandler = (e, type) => {

                let length = template.value.questions[type].questions.length;
                let lastElement = template.value.questions[type].questions[length - 1];
                let isErrors = false;
                let question = null;

                isErrors = freeTextQuestionsValidation(lastElement);
                question = {
                    question: '',
                    answer: '',
                    isDelete: true,
                    errors: {
                        question: [],
                        answer: []
                    }
                };


                if (!isErrors) {
                    addNewQuestionData(question, type)
                }

            };

            const deleteQuestionHandler = (idx, type) => {
                let errors = null;
                let element = template.value.questions.freeText.questions[idx];
                errors = freeTextQuestionsValidation(element);
                if (!errors)
                    decreaseTemplateQuestions(template, 'freeText');
                template.value.questions[type].questions.splice(idx, 1);
            };

            const answerTextChangeHandler = (e, idx, type) => {

                let element = template.value.questions[type].questions[idx];
                let errors = null;
                errors = freeTextQuestionsValidation(element);
                if (!errors)
                    increaseTemplateQuestions(template, 'freeText');
                else
                    decreaseTemplateQuestions(template, 'freeText');
            };

            const freeTextQuestionsValidation = (element) => {
                let isErrors = {
                    question: false,
                    answer: false
                };


                if (template.value.questions['freeText'].weight === null){
                    template.value.questions['freeText']['errors']['weight']['isError'] = true
                    template.value.questions['freeText']['errors']['weight']['message'] = '*Required'
                }

                isErrors.question = qustionValidation(element);

                if (element.answer === '') {
                    element.errors['answer'] = ['*Required'];
                    isErrors.answer = true;
                } else if (element.answer.length < 3) {
                    element.errors['answer'] = ['* Answer must be more than 2 characters'];
                    isErrors.question = true;
                } else if (element.answer.length > 500) {
                    element.errors['answer'] = ['* Answer must be less than 500 characters'];
                    isErrors.question = true;
                } else {
                    element.errors['answer'] = [];
                    isErrors.answer = false;
                }
                isErrors = isErrors.question || isErrors.answer;
                template.value.questions['freeText'].isError = isErrors;
                return isErrors;
            };

            const confirmModalHandler = (e) => {
                confirmFlag.value = false;
                if (e) {
                    template.value.questions['freeText'].questions = [{
                        question: '',
                        answer: '',
                        isDelete: true,
                        errors: {
                            question: [],
                            answer: []
                        }
                    }];
                    if (template.value.questions['freeText'].counter > 0) {
                        template.value.questions['freeText'].counter = 0;
                        template.value.questionsCount -= 1;
                    }
                    template.value.questions['freeText'].isError = false;
                }
            };
            const clearHandler = () => {
                template.value.questions['freeText'].weight = null;
                template.value.questions['freeText']['errors']['weight']['isError'] = false;
                template.value.questions['freeText']['errors']['weight']['message'] = '';

                if (template.value.questions['freeText'].counter > 0 || template.value.questions['freeText'].isError) {
                    confirmFlag.value = true;
                    confirmMsg.value = 'Are you sure you want to reset data?';
                }

            };
            const addNewQuestionData = (question, type) => {
                template.value.questions[type].questions.push(
                    question
                )
            };

            const checkErrors = (idx) => {
                let retVale = true;
                let errors = template.value.questions.freeText.questions[idx].errors;
                if (errors.question.length === 0 && errors.answer.length === 0) {
                    retVale = false;
                }
                return retVale;
            };

            return {
                template,
                confirmFlag,
                confirmMsg,
                lightMood: computed(() => store.state.settings.isLightMood),
                confirmModalHandler,
                addQuestionHandler,
                deleteQuestionHandler,
                freeTextQuestionsValidation,
                answerTextChangeHandler,
                addNewQuestionData,
                checkErrors,
                clearHandler,
                increaseTemplateQuestions,
                decreaseTemplateQuestions

            }
        }
    }

</script>

<style scoped>

    input[type=text] {
        height: 70px;
    }

    .input-section {
        height: 120px;
    }

    .weight-style {
        background-color: transparent;
        border: 1px solid #39525C;
        border-radius: 4px;
        width: 86px;
        height: 32px;
        color: #FFF;
        padding: 10px;
    }

    .q-weight-container {
        width: 18%;
    }

    .q-container {
        overflow-y: auto;
        padding: 20px;
        margin-top: 12px;
        background-color: #032A3A;
        border-radius: 20px;
        height: 92%;
    }

    .q-containerCopy {
        overflow-y: auto;
        padding: 20px;
        margin-top: 12px;
        /*background-color: #032A3A;*/
        border-radius: 20px;
        height: 92%;
    }

    .q-input {
        background-color: transparent !important;
        border: 1px solid #39525C;
        border-radius: 4px;
        color: var(--main-color);
        padding: 10px;
        overflow-y: scroll;
        overflow-x: hidden;
        min-height: 60px;
        max-height: 60px;
    }

    .q-input:focus,
    .q-input:focus-visible {
        outline: 0;
    }

    .add-question {
        font-size: 18px;
        font-weight: 500;
        cursor: pointer;
        color: #e65c00;
        border: 1px solid;
        border-radius: 50%;
        width: 25px;
        height: 25px;
        display: flex;
        justify-content: center;
        align-items: center;
        align-content: center;
    }

    .add-question:hover {
        background-color: #e65c00;
        color: #032a3a;
    }

    .m-c-answer-container > input[type=text],
    .m-c-answer-container > input[type=text]:focus,
    .m-c-answer-container > input[type=text]:focus-visible {
        border: 0;
        color: #FFF;
        background-color: transparent;
        outline: 0;
    }

</style>